import { TreeviewItem, TreeItem } from 'ngx-treeview';

export class ConvItems2Treeviewitem {
    convert(item4conv, naziv?){
        if (naziv==null){
            naziv="Naziv";
        }

        return this.convert1(item4conv, this, naziv);
    }

    constructor(){};

    convert1(item4conv, container, naziv)
    {
        var tmpTreeview: TreeviewItem[]=[];
        item4conv.forEach(function (value) {
            var tvi:TreeviewItem;
            var ti:cvor=new cvor();
            ti.text=value["Naziv"];
            ti.value=value.ID;
            if (value.Items!=null){
                ti.children=container.convert1(value.Items, container);
            }
            tvi=new TreeviewItem(ti as TreeItem);
            tmpTreeview.push(tvi);
        });
        return tmpTreeview
    }
}

export class cvor{
    text: string;
    value: number;
    children?: TreeItem[];
}
